module.exports = __webpack_public_path__ + "img/6.3349539b.png";